/* eslint-disable */
import { Link } from './common';
const baseLinkData = {};
export const LinkData = {
    fromJSON(object) {
        const message = Object.assign({}, baseLinkData);
        message.link =
            object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
        return obj;
    },
};
//# sourceMappingURL=decoration_link.js.map